import * as React from 'react';

import { observer } from 'mobx-react-lite';

import { Link } from 'react-router-dom';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkLink } from 'uitk-react-link';
import { UitkText } from 'uitk-react-text';

interface BreadcrumbsProps {
  crumbs: any[];
}

export const Breadcrumbs: React.FunctionComponent<BreadcrumbsProps> = ({ crumbs }) => {
  const crumbsList =
    crumbs &&
    crumbs.map((crumb, i) => {
      if (crumb.link) {
        return (
          <UitkLayoutFlexItem key={`crumb-${i}`}>
            <li>
              <UitkSpacing margin={{ inlineend: 'three' }}>
                <UitkLink inline={true}>
                  <Link to={crumb.link} className="a--no-hover">
                    {crumb.text}
                  </Link>
                </UitkLink>
              </UitkSpacing>
              <UitkSpacing margin={{ inlineend: 'three' }}>
                <UitkText inline={true} size={300} className="Breadcrumbs__slash">
                  &#47;
                </UitkText>
              </UitkSpacing>
            </li>
          </UitkLayoutFlexItem>
        );
      } else {
        return (
          <UitkLayoutFlexItem key={`crumb-${i}`}>
            <li>
              <UitkText size={300} inline={true}>
                {crumb.text}
              </UitkText>
            </li>
          </UitkLayoutFlexItem>
        );
      }
    });

  return (
    <UitkSpacing margin={{ blockend: 'two' }}>
      <nav className="Breadcrumbs">
        <UitkLayoutFlex tag="ul">{crumbsList}</UitkLayoutFlex>
      </nav>
    </UitkSpacing>
  );
};
